import React from 'react';
import { useSelector } from 'react-redux';
import { useTheme, Box, Typography, Chip, 
    Card, CardContent, Divider 
} from "@mui/material";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { hasPermission } from 'state/checkPermission';
import { formatTZDate } from 'state/helpers';
import FlexBetween from 'components/FlexBetween';


const CrewCompisitionList = ({ deadheadings = [], onClick }) => {
    const user = useSelector((state) => state.user); 
    const timeMode = useSelector((state) => state.timemode);
    const theme = useTheme();


    return (
        <Box display="flex" flexDirection="column" gap={2}>
            {deadheadings?.map((f, idx) => {
                const flightDate = timeMode === "UTC"
                    ? formatTZDate(f?.flightActualDayDep || f?.flightDate)
                    : formatTZDate(f?.flightActualDayDepLocalBase || f?.flightDateLocalBase);
                
                const td = timeMode === "UTC"
                    ? f?.atd || f?.etd
                    : f?.atdLocalBase || f?.etdLocalBase;

                const ta = timeMode === "UTC"
                    ? f?.ata || f?.eta
                    : f?.ataLocalBase || f?.etaLocalBase;

                const sortedCrewMembers = [...f.crewMembers]?.sort((a, b) => a.rankPriority - b.rankPriority) || [];

                return (
                    <Card
                        key={f._id}
                        variant="outlined"
                        sx={{
                            cursor: "pointer",
                            bgcolor: theme.palette.background.default,
                            borderRadius: 2,
                            border: `1px solid ${theme.palette.neutral.deep}`,
                            transition: "all 0.25s ease",
                            "&:hover": {
                                boxShadow: 2,
                                bgcolor: theme.palette.action.hover,
                            },
                            "&:active": {
                                transform: "scale(0.98)",
                                boxShadow: 1,
                            },
                        }}
                        onClick={() => {
                            hasPermission(user?.permissions, "Deadheadings", "view", false) &&
                            onClick && 
                            onClick(f)}
                        }
                    >
                        <CardContent sx={{ pt: 1.5, '&:last-child': { pb: 1.5 } }}>
                            <FlexBetween>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Chip
                                        label={idx + 1}
                                        variant="outlined"
                                        color={"primary"}
                                        size="small"
                                        sx={{
                                            fontSize: "0.75rem",
                                            borderWidth: 1.5,
                                            height: 20,
                                            "& .MuiChip-label": {
                                                px: 1,
                                            },
                                        }}
                                    />

                                    <Typography
                                        variant="body1"
                                        color={theme.palette.primary.dark}
                                    >
                                        {f.flightDesc}
                                    </Typography>
                                </Box>
                                
                                <Typography variant="body1" color="text.secondary">
                                    {flightDate}
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    {f.flightReg} | {f.acType}
                                </Typography>
                            </FlexBetween>
                            
                            <FlexBetween>                                
                                <Typography variant="body1" color="text.secondary">
                                    {td}
                                </Typography>
                                <Typography display="flex" alignItems="center" variant="body1" color="text.primary">
                                    {f.dep} <ArrowRightAltIcon/> {f.arr}
                                </Typography>
                                <Typography variant="body1" color="text.secondary">
                                    {ta}
                                </Typography>
                            </FlexBetween>

                            <Divider sx={{ my: 0.5 }} />

                            {sortedCrewMembers?.map((member, index) => { 
                                return (
                                    <Box
                                        key={index}
                                        display="flex"
                                        alignItems="center"
                                        alignContent='flex-start'
                                        gap={1}
                                        sx={{
                                        color: member?.gender === 'FM' 
                                            ? theme.palette.secondary.main 
                                            : theme.palette.primary.dark,
                                        }}
                                    >
                                        <Typography 
                                            width="18px" 
                                            textAlign='right' 
                                        >
                                            {index + 1}. 
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                textAlign: 'right',
                                                whiteSpace: 'nowrap',
                                                width: '30px',
                                            }}
                                        >
                                            {member.crewCode}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                textAlign: 'left',
                                            }}
                                        >
                                            {member.crewName}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                textAlign: 'center',
                                            }}
                                        >
                                            ({member.post} | {member.base}{member.trnDuty && ` | ${member.trnDuty}`})
                                        </Typography>                
                                    </Box>
                                )
                            })}
                        </CardContent>
                    </Card>
                )
            })}
        </Box>
    );
};

export default CrewCompisitionList;
